var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ReprogramarCronograma"),
      _vm._v(" "),
      _c("VerDetalle"),
      _vm._v(" "),
      _c(
        "h4",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Vacaciones programadas " + _vm._s(this.$route.params.gestion)
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          !!_vm.estado_vacacion
            ? _c(
                "v-card-text",
                [
                  _c("DatosPersonalesProgramacion", {
                    attrs: { id_estado_vacacion: _vm.estado_vacacion.id },
                    model: {
                      value: _vm.total_dias_programar,
                      callback: function($$v) {
                        _vm.total_dias_programar = $$v
                      },
                      expression: "total_dias_programar"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "text-xs-center py-1" },
            [
              _c(
                "v-card",
                { staticClass: "px-3 white--text", attrs: { color: "indigo" } },
                [
                  _c("span", { staticClass: "caption" }, [
                    _vm._v("NÚMERO DE DÍAS RESTANTES A PROGRAMAR")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "display-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.total_dias_programar - _vm.total_dias_programados
                      )
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container-rrhh"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nro papeleta" },
                              on: { input: _vm.filterSecuencia },
                              model: {
                                value: _vm.form.secuencia,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "secuencia", $$v)
                                },
                                expression: "form.secuencia"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha salida" },
                              on: { input: _vm.filterFechaDesde },
                              model: {
                                value: _vm.form.ap_paterno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_paterno", $$v)
                                },
                                expression: "form.ap_paterno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha fin" },
                              on: { input: _vm.filterFechaHasta },
                              model: {
                                value: _vm.form.fecha_hasta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fecha_hasta", $$v)
                                },
                                expression: "form.fecha_hasta"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Dias" },
                              on: { input: _vm.filterTotalDias },
                              model: {
                                value: _vm.form.total_dias,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_dias", $$v)
                                },
                                expression: "form.total_dias"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Estado" },
                              on: { input: _vm.filterEstado },
                              model: {
                                value: _vm.form.estado,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "estado", $$v)
                                },
                                expression: "form.estado"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      small: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.recargar()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("refresh")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Recargar filtros")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return function() {
                                          _vm.filterShow = false
                                          _vm.recargar()
                                        }.apply(null, arguments)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_programaciones,
                  "hide-actions": "",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.secuencia))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_desde)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_hasta)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.total_dias))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado))
                        ])
                      ]
                    }
                  },
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _c(
                          "td",
                          {
                            staticClass: "footer-table",
                            attrs: { colspan: "3" }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s("Total dias programados"))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center title" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.total_dias_programados))
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fc77366", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc77366","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/ProgramacionesPorFuncionario.vue
// module id = null
// module chunks = 